import InputSelect from "components/Input/InputSelect/InputSelect";
import RankChart from "components/RankChart/RankChart";
import salesData from 'mock/mockSales.json';




interface IProducts {}
const ProductsNotBought: React.FC<IProducts> = () => {

  const CustomHeader = () => {
    return(
      <>
        <InputSelect></InputSelect>
      </>
    )
  }


  return(
    <div style={{paddingTop: '10vh'}}>
      <RankChart 
        headerTitle="Products Bought"
        customHeader={CustomHeader()} columns={[]} data={salesData} isLoading={false}  />
    </div>
  )
}

export default ProductsNotBought;